<template lang="html">
    <div class="default-page-paddings">
        <div class="container container-medium ">
            <Heading :title="$t('distribution')"></Heading>
            <div class="default-content">
                <p class="heading-small">
                    {{ $t('distribution_header') }}
                </p>
                <table class="table table-bordered table-responsive-md">
                    <thead>
                        <tr>
                            <th scope="col">
                                {{ $t('distribution_nr_crt') }}
                            </th>
                            <th scope="col">{{ $t('distribution_work_point') }}</th>
                            <th scope="col">{{ $t('label_county') }}</th>
                            <th scope="col">{{ $t('label_locality') }}</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr>
                            <th scope="row">1</th>
                            <td>
                                ARAD<br/>
                                0720-999.231
                            </td>
                            <td>ARAD</td>
                            <td>ARAD, STR. PRUNULUI NR. 66</td>
                        </tr>
                        <tr>
                            <th scope="row">2</th>
                            <td>
                                LIPOVA<br/>
                                0720-999.231
                            </td>
                            <td>ARAD</td>
                            <td>LIPOVA, STR. SLT. SUCIU SORIN NR. 134F</td>
                        </tr>
                        <tr>
                            <th scope="row">3</th>
                            <td>
                                PITEȘTI<br/>
                                0720-999.230<br/>
                                0720-999.209
                            </td>
                            <td>ARGEȘ</td>
                            <td>PITEȘTI, CARTIER POPA ȘAPCĂ, STR. SF. VINERI, BL. P16, SC. B, AP. 2, PARTER</td>
                        </tr>
                        <tr>
                            <th scope="row">4</th>
                            <td>
                                ORADEA<br/>
                                0720-999.259
                            </td>
                            <td>BIHOR</td>
                            <td>ORADEA, SOS. BORȘULUI NR. 53</td>
                        </tr>
                        <tr>
                            <th scope="row">5</th>
                            <td>
                                BUCUREȘTI<br>
                                0720-999.253
                            </td>
                            <td>BUCUREȘTI</td>
                            <td>BUCUREȘTI, STR. IENĂCHIȚĂ VĂCĂRESCU NR. 60, SECT. 4</td>
                        </tr>
                        <tr>
                            <th scope="row">6</th>
                            <td>
                                CLUJ<br/>
                                0720-999.250
                            </td>
                            <td>CLUJ</td>
                            <td>CLUJ NAPOCA, STR. TRAIAN NR. 48</td>
                        </tr>
                        <tr>
                            <th scope="row">7</th>
                            <td>
                                DEVA<br/>
                                0720-999.205
                            </td>
                            <td>HUNEDOARA</td>
                            <td>DEVA, B-DUL NICOLAE BĂLCESCU, NR. 24B, AP. 1A, COMPLEX VILLA PARK</td>
                        </tr>
                        <tr>
                            <th scope="row">8</th>
                            <td>
                                REDIU<br/>
                                0720-999.242<br/>
                                0720-999.228
                            </td>
                            <td>IAȘI</td>
                            <td>REDIU, BLOC DIANA, TRONSON 2, DEMISOL</td>
                        </tr>
                        <tr>
                            <th scope="row">9</th>
                            <td>
                                TÂRGU MUREȘ<br/>
                                0720-999.244
                            </td>
                            <td>MUREȘ</td>
                            <td>TÂRGU MUREȘ, STR. CĂLĂRAȘILOR NR. 82</td>
                        </tr>
                        <tr>
                            <th scope="row">10</th>
                            <td>
                                SATU MARE<br/>
                                0720-999.247
                            </td>
                            <td>SATU MARE</td>
                            <td>SATU MARE, STR. MARTIRILOR DEPORTAȚI NR. 10</td>
                        </tr>
                        <tr>
                            <th scope="row">11</th>
                            <td>
                                SIBIU<br/>
                                0720-999.246
                            </td>
                            <td>SIBIU</td>
                            <td>SIBIU, STR. COJOCARILOR, NR. 2</td>
                        </tr>
                        <tr>
                            <th scope="row">12</th>
                            <td>
                                SUCEAVA<br/>
                                0720-999.248
                            </td>
                            <td>SUCEAVA</td>
                            <td>SUCEAVA, STR. ȘTEFAN CEL MARE NR. 47, BL. A1, SC. A, AP. 2</td>
                        </tr>
                        <tr>
                            <th scope="row">13</th>
                            <td>
                                TIMIȘOARA<br/>
                                0720-999.207
                            </td>
                            <td>TIMIȘ</td>
                            <td>TIMIȘOARA, B-DUL TAKE IONESCU NR. 51</td>
                        </tr>
                    </tbody>
                </table>
                <p class="main-text"> {{ $t('distribution_terminals_and_portals') }} </p>
                <table class="table table-bordered">
                    <thead>
                        <tr>
                            <th scope="col">{{ $t('distribution_nr_crt') }}</th>
                            <th scope="col">{{ $t('distribution_name') }}</th>
                            <th scope="col">{{ $t('label_locality') }}</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr>
                            <th scope="row">1</th>
                            <td>{{ $t('distribution_terminals') }}</td>
                            <td>{{ $t('distribution_location_terminal_details') }}: <a target="_blank" href="https://selfpay.ro/">www.zebrapay.ro</a></td>
                        </tr>
                        <tr>
                            <th scope="row">2</th>
                            <td>{{ $t('distribution_untrr_portal') }}</td>
                            <td>www.e-rovinieta.ro</td>
                        </tr>
                    </tbody>
                </table>
            </div>
        </div>
    </div>
</template>

<script>

import Heading from './snippets/Heading.vue'
import { mapState } from 'vuex'

export default {
    name: 'Distribution',
    components: {
        Heading
    },
    props: {

    },
    computed: {
        ...mapState('language', [
            'locale'
        ])
    }
}

</script>

<style lang="scss" scoped>

</style>
